import React, { Component } from "react";
import { Card, Button, Header } from "semantic-ui-react";
import PropTypes from "prop-types";
import Constants from "../utilities/Constants";
import Strings from "../utilities/StringSelector";
// import Utils from "../utilities/Utils";
import { connect } from "react-redux";
import { solveProblemAction } from "../../actions/changeActiveItemActions";
// const UtilsInstance = new Utils();

export class ProblemCard extends Component {
  // Intialize this component state
  constructor(props) {
    super(props);
    this.state = {};
  }

  getProblemHeader = () => {
    if (this.props.problem.type === Constants.DIAGNOSTIC_ERROR_TYPE) {
      return (
        <Card.Header style={{ marginBottom: "2px" }}>
          {Strings.DEVICE_WITH_DIAGNOSTIC}
        </Card.Header>
      );
    }
    else if (this.props.problem.type === Constants.FAULT_ERROR_TYPE) {
      return (
        <Card.Header style={{ marginBottom: "2px" }}>
          {Strings.DEVICE_WITH_FAULT}
        </Card.Header>
      );
    }
    else if (this.props.problem.type === Constants.DUPLICATE_IP_ERROR_TYPE) {
      return (
        <Card.Header style={{ marginBottom: "2px" }}>
          {Strings.DEVICES_WITH_DUPLICATE_IP}
        </Card.Header>
      );
    }
    else if (this.props.problem.type === Constants.DUPLICATE_NAME_ERROR_TYPE) {
      return (
        <Card.Header style={{ marginBottom: "2px" }}>
          {Strings.DEVICES_WITH_DUPLICATE_NAME}
        </Card.Header>
      );
    }
    else if (this.props.problem.type === Constants.PING_ERROR_TYPE) {
      return (
        <Card.Header style={{ marginBottom: "2px" }}>
          {Strings.PING_LIMIT_EXCEEDED}
        </Card.Header>
      );
    }
    else if (this.props.problem.type === Constants.DELTA_ERROR_TYPE) {
      return (
        <Card.Header style={{ marginBottom: "2px" }}>
          {Strings.DELTA_ERROR_ALARM}
        </Card.Header>
      );
    }
    else if (this.props.problem.type === Constants.NOT_IN_FULL_DUPLEX_ERROR_TYPE) {
      return (
        <Card.Header style={{ marginBottom: "2px" }}>
          {Strings.PORT_NOT_IN_FULL_DUPLEX}
        </Card.Header>
      );
    }
    else if (this.props.problem.type === Constants.TRAFFIC_EXCESS_ERROR_TYPE) {
      return (
        <Card.Header style={{ marginBottom: "2px" }}>
          {Strings.TRAFFIC_EXCESS}
        </Card.Header>
      );
    }
    else if (this.props.problem.type === Constants.INACTIVE_PORT_ERROR_TYPE) {
      return (
        <Card.Header style={{ marginBottom: "2px" }}>
          {Strings.INACTIVE_PORT}
        </Card.Header>
      );
    }
    else if (this.props.problem.type === Constants.HW_FW_ERROR_TYPE) {
      return (
        <Card.Header style={{ marginBottom: "2px" }}>
          {Strings.HW_FW}
        </Card.Header>
      );
    }
    else if (this.props.problem.type === Constants.MODULE_INCOHERENCE_ERROR_TYPE) {
      return (
        <Card.Header style={{ marginBottom: "2px" }}>
          {Strings.MODULE_INCOHERENCE}
        </Card.Header>
      );
    }
    else if (this.props.problem.type === Constants.DUPLEX_MISMATCH_ERROR_TYPE) {
      return (
        <Card.Header style={{ marginBottom: "2px" }}>
          {Strings.DUPLEX_MISMATCH}
        </Card.Header>
      );
    }
    else if (this.props.problem.type === Constants.DELAY_ERROR_TYPE) {
      return (
        <Card.Header style={{ marginBottom: "2px" }}>
          {Strings.DELAY_EXCEEDED}
        </Card.Header>
      );
    }
    else if (this.props.problem.type === Constants.INTERMITENT_FAILURE_ERROR_TYPE) {
      return (
        <Card.Header style={{ marginBottom: "2px" }}>
          {Strings.DEVICE_WITH_INTERMITTENT_FAILURE}
        </Card.Header>
      );
    }
    else if (this.props.problem.type === Constants.LOST_IP_ERROR_TYPE) {
      return (
        <Card.Header style={{ marginBottom: "2px" }}>
          {Strings.DEVICE_WITH_LOST_IP}
        </Card.Header>
      );
    }
    else {
      return "";
    }
  }

  formatTime = () => {
    if (this.props.problem.ntp !== null && this.props.problem.ntp === true && this.props.problem.time !== null) {
      let parsedMillis = Date.parse(this.props.problem.time);
      let dateToShow = new Date(parsedMillis);
      return dateToShow.toLocaleString("pt-BR");
    }
    else if (this.props.problem.time !== undefined && this.props.problem.time !== null) {
      const eventTimeInMillis = this.props.problem.time * 1000;
      const timeNow = this.props.nowMillis;
      const time = timeNow - eventTimeInMillis;
      const dateToShow = new Date(time);
      return (dateToShow.toLocaleString("pt-BR"));
    }
    else {
      return Strings.BEFORE_MONITOR_INIT_STR;
    }
  }

  getProblemMeta = () => {
    let problemDate = this.formatTime();

    return (
      <Card.Meta>
        <strong>
          {Strings.DETECTED_ON}
          {problemDate}
        </strong>
      </Card.Meta>
    );
  }

  getIpName = (ips, macs) => {
    let ipsAndMacs = [];

    for (let i = 0; i < ips.length; i++) {
      ipsAndMacs.push({
        "ip": ips[i],
        "mac": macs[i]
      });
    }
    return ipsAndMacs;
  }

  getProblemDescription = () => {
    if (this.props.problem.type === Constants.DIAGNOSTIC_ERROR_TYPE) {
      return (
        <React.Fragment>
          <Card.Description>
            <Header as="h4" style={headerStyle}>{Strings.DEVICE}:</Header>
            <p>
              <b>{Strings.IP}:</b> {this.props.problem.ip} <br />
              <b>{Strings.MAC}:</b> {this.props.problem.mac.toUpperCase()} <br />
              <b>{Strings.NAME}:</b> {this.props.problem.name} <br />
              <b>{Strings.ALARMS_DP}</b> {this.props.problem.total} <br />
            </p>
          </Card.Description>
        </React.Fragment>
      );
    }
    else if (this.props.problem.type === Constants.FAULT_ERROR_TYPE) {
      return (
        <React.Fragment>
          <Card.Description>
            <Header as="h4" style={headerStyle}>{Strings.DEVICE}:</Header>
            <p>
              <b>{Strings.IP}:</b> {this.props.problem.ip} <br />
              <b>{Strings.MAC}:</b> {this.props.problem.mac.toUpperCase()} <br />
              <b>{Strings.NAME}:</b> {this.props.problem.name} <br />
              <b>{Strings.FAULTS_DP}</b> {this.props.problem.total} <br />
            </p>
          </Card.Description>
        </React.Fragment>
      );
    }
    else if (this.props.problem.type === Constants.DUPLICATE_IP_ERROR_TYPE) {
      return (
        <React.Fragment>
          <Card.Description>
            <p><strong>{Strings.DUPLICATE_IP_CARD_DESC}</strong> {this.props.problem.ip}</p>
            <ul>
              {
                this.props.problem.macs.map(mac => (
                  <li key={mac}><strong>{Strings.MAC}: </strong> {mac.toUpperCase()}</li>
                ))
              }
            </ul>
          </Card.Description>
        </React.Fragment>
      );
    }
    else if (this.props.problem.type === Constants.DUPLICATE_NAME_ERROR_TYPE) {
      let ipsAndMacs = [];

      for (let i = 0; i < this.props.problem.ips.length; i++) {
        ipsAndMacs.push({
          "ip": this.props.problem.ips[i],
          "mac": this.props.problem.macs[i]
        });
      }

      return (
        <React.Fragment>
          <Card.Description>
            <p><strong>{Strings.DUPLICATE_NAME_CARD_DESC}</strong> {this.props.problem.name} </p>
            <ul>
              {
                ipsAndMacs.map(ipAndMac => (
                  <li key={ipAndMac.mac}>
                    <strong>IP: </strong> {ipAndMac.ip.toUpperCase()} /
                    <strong> MAC: </strong> {ipAndMac.mac.toUpperCase()}
                  </li>
                ))
              }
            </ul>
          </Card.Description>
        </React.Fragment>
      );
    }
    else if (this.props.problem.type === Constants.PING_ERROR_TYPE) {
      return (
        <React.Fragment>
          <Card.Description>
            <Header as="h4" style={headerStyle}>{Strings.DEVICE}:</Header>
            <p>
              <b>{Strings.IP}:</b> {this.props.problem.ip} <br />
              <b>{Strings.MAC}:</b> {this.props.problem.mac.toUpperCase()} <br />
              <b>{Strings.NAME}:</b> {(this.props.problem.product_name != null) ? this.props.problem.product_name : Strings.UNKNOWN} <br />
              <b>{Strings.REGISTERED_PING}</b> {this.props.problem.ping.toFixed(2)} ms
            </p>
          </Card.Description>
        </React.Fragment>
      );
    }
    else if (this.props.problem.type === Constants.DELTA_ERROR_TYPE) {
      let portsString = "";

      for (let port of this.props.problem.ports) {
        portsString += port + ", ";
      }

      portsString = portsString.substring(0, portsString.length - 2);

      return (
        <React.Fragment>
          <Card.Description>
            <Header as="h4" style={headerStyle}>{Strings.DEVICE_HAS_DELTA_ERROR_PROBLEMS}</Header>
            <p>
              <b>{Strings.IP}:</b> {this.props.problem.ip} <br />
              <b>{Strings.MAC}:</b> {this.props.problem.mac.toUpperCase()} <br />
              <b>{Strings.PORTS}:</b> {portsString} <br />
            </p>
          </Card.Description>
        </React.Fragment>
      );
    }
    else if (this.props.problem.type === Constants.NOT_IN_FULL_DUPLEX_ERROR_TYPE) {
      return (
        <React.Fragment>
          <Card.Description>
            <Header as="h4" style={headerStyle}>{Strings.DEVICE}:</Header>
            <p>
              <b>{Strings.IP}:</b> {this.props.problem.ip} <br />
              <b>{Strings.MAC}:</b> {this.props.problem.mac.toUpperCase()} <br />
              <b>{Strings.NAME}:</b> {this.props.problem.name} <br />
              <b>{Strings.PORT}:</b> {this.props.problem.portName} <br />
              <b>{Strings.DUPLEX_MODE}:</b> {this.props.problem.MAUType} <br />
            </p>
          </Card.Description>
        </React.Fragment>
      );
    }
    else if (this.props.problem.type === Constants.TRAFFIC_EXCESS_ERROR_TYPE) {
      let portsString = "";

      for (let port of this.props.problem.ports) {
        portsString += port + ", ";
      }

      portsString = portsString.substring(0, portsString.length - 2);

      return (
        <React.Fragment>
          <Card.Description>
            <Header as="h4" style={headerStyle}>{Strings.DEVICE_HAS_TRAFFIC_EXCESS_ERROR_PROBLEMS}</Header>
            <p>
              <b>{Strings.IP}:</b> {this.props.problem.ip} <br />
              <b>{Strings.MAC}:</b> {this.props.problem.mac.toUpperCase()} <br />
              <b>{Strings.PORTS}:</b> {portsString} <br />
            </p>
          </Card.Description>
        </React.Fragment>
      );
    }
    else if (this.props.problem.type === Constants.INACTIVE_PORT_ERROR_TYPE) {
      return (
        <React.Fragment>
          <Card.Description>
            <Header as="h4" style={headerStyle}>{Strings.DEVICE}:</Header>
            <p>
              <b>{Strings.IP}:</b> {this.props.problem.ip} <br />
              <b>{Strings.MAC}:</b> {this.props.problem.mac.toUpperCase()} <br />
              <b>{Strings.NAME}:</b> {this.props.problem.name} <br />
              <b>{Strings.PORT}:</b> {this.props.problem.portName} <br />
            </p>
          </Card.Description>
        </React.Fragment>
      );
    }
    else if (this.props.problem.type === Constants.HW_FW_ERROR_TYPE) {
      let devices = [];

      for (let i = 0; i < this.props.problem.names.length; i++) {
        devices.push({
          "name": this.props.problem.names[i],
          "ip": this.props.problem.ips[i],
          "mac": this.props.problem.macs[i],
          "firmware": this.props.problem.firmwares[i],
        });
      }

      return (
        <React.Fragment>
          <Card.Description>
            <p>{Strings.SAME_HW_DIFF_FW}:</p>
            <p><strong> {Strings.HARDWARE_VERSION_N}:</strong> {this.props.problem.hardwareVersion} </p>
            <ul>
              {
                devices.map(device => {
                  return (
                    <li key={device.mac}>
                      <strong>{Strings.IP}:</strong> {device.ip} <b>/</b>
                      <strong> {Strings.MAC}:</strong> {device.mac} <b>/</b>
                      <strong> {Strings.NAME}:</strong> {device.name} <b>/</b>
                      <strong> {Strings.FIRMWARE}:</strong> {device.firmware}
                    </li>
                  );
                })
              }
            </ul>

          </Card.Description>
        </React.Fragment>
      );
    }
    else if (this.props.problem.type === Constants.MODULE_INCOHERENCE_ERROR_TYPE) {
      let realInfo = {
        "identNumber": "",
        "infoText": "",
        "moduleName": "",
        "orderNumber": "",
      };

      let expectedInfo = {
        "identNumber": "",
        "infoText": "",
        "moduleName": "",
        "orderNumber": "",
      };

      realInfo.identNumber = this.props.problem.identNumbers[0];
      realInfo.infoText = this.props.problem.infoTexts[0];
      realInfo.moduleName = this.props.problem.moduleNames[0];
      realInfo.orderNumber = this.props.problem.orderNumbers[0];

      expectedInfo.identNumber = this.props.problem.identNumbers[1];
      expectedInfo.infoText = this.props.problem.infoTexts[1];
      expectedInfo.moduleName = this.props.problem.moduleNames[1];
      expectedInfo.orderNumber = this.props.problem.orderNumbers[1];

      return (
        <React.Fragment>
          <Card.Description>
            <p><strong> {Strings.INCOHERENCE_IN_MODULE}:</strong> {this.props.problem.module}</p>
            <Header as="h4" style={headerStyle}>{Strings.RECEIVED_INFO_DP}</Header>
            <p>
              <b>Ident number:</b> {realInfo.identNumber}<br />
              <b>Info text:</b> {realInfo.infoText}<br />
              <b>{Strings.MODULE_NUMBER_DP}</b> {realInfo.moduleName}<br />
              <b>Order number:</b> {realInfo.orderNumber}<br />
            </p>
            <Header as="h4" style={headerStyle}>{Strings.EXPECTED_INFO_DP}</Header>
            <p>
              <b>Ident number:</b> {expectedInfo.identNumber}<br />
              <b>Info text:</b> {expectedInfo.infoText}<br />
              <b>{Strings.MODULE_NUMBER_DP}</b> {expectedInfo.moduleName}<br />
              <b>Order number:</b> {expectedInfo.orderNumber}<br />
            </p>

          </Card.Description>
        </React.Fragment>
      );
    }
    else if (this.props.problem.type === Constants.DUPLEX_MISMATCH_ERROR_TYPE) {
      let device1 = {
        "ip": "",
        "mac": "",
        "name": "",
        "portName": "",
        "MAUType": ""
      };

      let device2 = {
        "ip": "",
        "mac": "",
        "name": "",
        "portName": "",
        "MAUType": ""
      };

      device1.ip = this.props.problem.ips[0];
      device1.mac = this.props.problem.macs[0];
      device1.name = this.props.problem.names[0];
      device1.portName = this.props.problem.portNames[0];
      device1.MAUType = this.props.problem.MAUTypes[0];

      device2.ip = this.props.problem.ips[1];
      device2.mac = this.props.problem.macs[1];
      device2.name = this.props.problem.names[1];
      device2.portName = this.props.problem.portNames[1];
      device2.MAUType = this.props.problem.MAUTypes[1];

      return (
        <React.Fragment>
          <Card.Description>
            <Header as="h4" style={headerStyle}>{Strings.DEVICE}:</Header>
            <p>
              <b>{Strings.IP}:</b> {device1.ip} <br />
              <b>{Strings.MAC}:</b> {device1.mac} <br />
              <b>{Strings.NAME}:</b> {device1.name} <br />
              <b>{Strings.PORT}:</b> {device1.portName} <br />
              <b>{Strings.DUPLEX_MODE}:</b> {device1.MAUType} <br />
            </p>

            <Header as="h4" style={headerStyle}>{Strings.DEVICE}:</Header>
            <p>
              <b>{Strings.IP}:</b> {device2.ip} <br />
              <b>{Strings.MAC}:</b> {device2.mac} <br />
              <b>{Strings.NAME}:</b> {device2.name} <br />
              <b>{Strings.PORT}:</b> {device2.portName} <br />
              <b>{Strings.DUPLEX_MODE}:</b> {device2.MAUType} <br />
            </p>

          </Card.Description>
        </React.Fragment>
      );
    }
    else if (this.props.problem.type === Constants.DELAY_ERROR_TYPE) {
      return (
        <React.Fragment>
          <Card.Description>
            <Header as="h4" style={headerStyle}>{Strings.DEVICE}:</Header>
            <p>
              <b>{Strings.IP}:</b> {this.props.problem.ip} <br />
              <b>{Strings.MAC}:</b> {this.props.problem.mac.toUpperCase()} <br />
              <b>{Strings.NAME}:</b> {this.props.problem.product_name} <br />
              <b>{Strings.PORT}:</b> {this.props.problem.portName} <br />
              <b>{Strings.LINE_DELAY_VALUE_1}:</b> {this.props.problem.lineDelay} ns<br />
            </p>
          </Card.Description>
        </React.Fragment>
      );
    }
    else if (this.props.problem.type === Constants.INTERMITENT_FAILURE_ERROR_TYPE) {
      return (
        <React.Fragment>
          <Card.Description>
            <Header as="h4" style={headerStyle}>{Strings.DEVICE}:</Header>
            <p>
              <b>{Strings.IP}:</b> {this.props.problem.ip} <br />
              <b>{Strings.MAC}:</b> {this.props.problem.mac.toUpperCase()} <br />
              <b>{Strings.NAME}:</b> {this.props.problem.product_name} <br />
              <b>{Strings.FAULTS_DP}:</b> {this.props.problem.failures} <br />
            </p>
          </Card.Description>
        </React.Fragment>
      );
    }
    else if (this.props.problem.type === Constants.LOST_IP_ERROR_TYPE) {
      return (
        <React.Fragment>
          <Card.Description>
            <Header as="h4" style={headerStyle}>{Strings.DEVICE}:</Header>
            <p>
              <b>{Strings.IP}:</b> 0.0.0.0 <br />
              <b>{Strings.MAC}:</b> {this.props.problem.mac.toUpperCase()} <br />
              <b>{Strings.MODEL}:</b> {this.props.problem.model} <br />
            </p>
          </Card.Description>
        </React.Fragment>
      );
    }
    else {
      return "";
    }
  }

  handleSolvedButtonClick = async () => {
    this.props.onProblemSolve(true, this.props.problem);
  }

  render() {
    return (
      <Card id={this.props.problem._id} fluid raised>
        <Card.Content>
          {this.getProblemHeader()}
          {this.getProblemMeta()}
          {this.getProblemDescription()}
        </Card.Content>
        <Card.Content extra>
          <Button
            basic
            color='green'
            fluid
            onClick={this.handleSolvedButtonClick}>
            {Strings.CHECKED}
          </Button>
        </Card.Content>
      </Card >
    );
  }
}

const mapStateToProps = state => ({
  active: state
});

const mapActionsToProps = {
  onProblemSolve: solveProblemAction
};

ProblemCard.propTypes = {
  nowMillis: PropTypes.number.isRequired,
  startTime: PropTypes.number.isRequired,
  problem: PropTypes.object.isRequired,
  onProblemSolve: PropTypes.func
};

const headerStyle = {
  marginTop: "8px",
  marginBottom: "8px",
};

export default connect(mapStateToProps, mapActionsToProps)(ProblemCard);
